<template>
  <img :src="`/public/images/logos/${name}.png`" alt="Logo de La Prensa Gráfica - Grupo Dutriz" />
</template>

<script>
export default {
  name: 'LogoLPG',
  props: {
    name: String,
    validator(value) {
      return [
        'grupo-lpg-blue',
        'grupo-lpg-white',
        'la-prensa-grafica',
        'lpg-blue',
        'lpg-white',
      ].includes(value)
    },
  },
}
</script>
